// MARK://dhk8/pos/lib/queries/contacts
// Queries+mutations tipadas de clientes CRM (crm-contacts) — F9.12 / ADR-0008/0009.
// El POS lee/escribe contactos por el grafo (tenant del JWT). El modelo CRM es
// 1 Contact con N FiscalEntity[]; el cliente POS aplana cada par a un CustomerDto.
// Escrituras = variante RLS B (guard IDOR en el resolver). tenant NUNCA va como arg.
import { graphql } from '../../gql/index.js'

export const PosContactsQuery = graphql(`
  query PosContacts($limit: Int, $q: String) {
    contacts(limit: $limit, q: $q) {
      items {
        id
        tenantId
        firstName
        lastName
        fullName
        emails { id email label isPrimary }
        phones { id phone label isPrimary }
        fiscalEntities { id rfc legalName regimeCode zipCode usoCfdi invoiceEmail isDefault }
      }
      total
      page
      limit
    }
  }
`)

export const PosContactQuery = graphql(`
  query PosContact($id: ID!) {
    contact(id: $id) {
      id
      tenantId
      firstName
      lastName
      fullName
      emails { id email label isPrimary }
      phones { id phone label isPrimary }
      fiscalEntities { id rfc legalName regimeCode zipCode usoCfdi invoiceEmail isDefault }
    }
  }
`)

export const PosCreateContactMutation = graphql(`
  mutation PosCreateContact($input: CrmCreateContactInput!) {
    createContact(input: $input) {
      id
      tenantId
      firstName
      lastName
      fullName
      emails { id email label isPrimary }
      phones { id phone label isPrimary }
      fiscalEntities { id rfc legalName regimeCode zipCode usoCfdi invoiceEmail isDefault }
    }
  }
`)

export const PosUpdateContactMutation = graphql(`
  mutation PosUpdateContact($id: ID!, $input: CrmUpdateContactInput!) {
    updateContact(id: $id, input: $input) {
      id
      tenantId
      firstName
      lastName
      fullName
      emails { id email label isPrimary }
      phones { id phone label isPrimary }
      fiscalEntities { id rfc legalName regimeCode zipCode usoCfdi invoiceEmail isDefault }
    }
  }
`)
